@if (holidayName && closeButton) {
  <div class="hold-banner-container">
    <wcg-banner
      [bannerType]="warningBannerType"
      [closeButton]="true"
      ($handleBannerClose)="handOnClose()"
    >
      <div class="hold-banner-content">
        <div class="hold-banner-header">
          @let hDate =
            doubleHoliday
              ? doubleHolidayStart + " to " + doubleHolidayEnd
              : holidayDate;
          <p>
            Our offices will be closed on {{ hDate }} in recognition of
            {{ holidayName }}. Although the office is currently closed, you may
            still make IRB submissions and access your documents through WCG’s
            eReview Manager. Live Support will respond in a timely manner
            upon our return to the office.
          </p>
        </div>
      </div>
    </wcg-banner>
  </div>
}
